import type { Brand } from "./Brand"

export type GUID = Brand<bigint, "GUID">
export type StringGUID = Brand<string, "GUID">
export type AnyGUID = GUID | StringGUID
